import React from "react";
import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";

const formatCurrency = (value) =>
  new Intl.NumberFormat("en-US").format(
    value
  );

export default function NetProfit(props) {
  
    let financialData = props.data;
    let onClose = props.onClose

  return (
    <div
      style={{
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        margin: "0 auto",
        backgroundColor: "#f8fafc",
        color: "#334155",
        borderRadius: "16px",
        boxShadow:
          "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.03)",
      }}
    >
      

      {/* 1. DATA TABLE SECTION */}
      <div
        style={{
          overflowX: "auto",
          marginBottom: "40px",
          backgroundColor: "#ffffff",
          border: "1px solid #e2e8f0",
          borderRadius: "12px",
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.02)",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            textAlign: "left",
            fontSize: "14px",
          }}
        >
          <thead>
            <tr
              style={{
                borderBottom: "1px solid #e2e8f0",
                backgroundColor: "#f1f5f9",
              }}
            >
              <th
                style={{
                  padding: "16px",
                  fontWeight: "600",
                  color: "#475569",
                  textTransform: "uppercase",
                  fontSize: "12px",
                  letterSpacing: "0.05em",
                }}
              >
                Performance Month
              </th>
              <th
                style={{
                  padding: "16px",
                  fontWeight: "600",
                  color: "#16a34a",
                  textTransform: "uppercase",
                  fontSize: "12px",
                  letterSpacing: "0.05em",
                }}
              >
                Income
              </th>
              <th
                style={{
                  padding: "16px",
                  fontWeight: "600",
                  color: "#dc2626",
                  textTransform: "uppercase",
                  fontSize: "12px",
                  letterSpacing: "0.05em",
                }}
              >
                Expense
              </th>
              <th
                style={{
                  padding: "16px",
                  fontWeight: "600",
                  color: "#2563eb",
                  textTransform: "uppercase",
                  fontSize: "12px",
                  letterSpacing: "0.05em",
                }}
              >
                Net Profit
              </th>
              <th
                style={{
                  padding: "16px",
                  fontWeight: "600",
                  color: "#d97706",
                  textTransform: "uppercase",
                  fontSize: "12px",
                  letterSpacing: "0.05em",
                }}
              >
                Profit Percent
              </th>
            </tr>
          </thead>
          <tbody>
            {financialData.map((row) => (
              <tr
                key={row.Month}
                style={{
                  borderBottom: "1px solid #e2e8f0",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f8fafc")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                <td
                  style={{
                    padding: "16px",
                    fontWeight: "600",
                    color: "#334155",
                  }}
                >
                  {row.Month}
                </td>
                <td
                  style={{
                    padding: "16px",
                    color: "#16a34a",
                    fontWeight: "500",
                  }}
                >
                  {row.Income}
                </td>
                <td
                  style={{
                    padding: "16px",
                    color: "#dc2626",
                    fontWeight: "500",
                  }}
                >
                  {row.Expense}
                </td>
                <td
                  style={{
                    padding: "16px",
                    color: "#2563eb",
                    fontWeight: "600",
                  }}
                >
                  {row.NetProfit}
                </td>
                <td
                  style={{
                    padding: "16px",
                    color: "#d97706",
                    fontWeight: "600",
                  }}
                >
                  {row.ProfitPercent.toFixed(2)}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 2. GRAPH SECTION */}
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "24px",
          border: "1px solid #e2e8f0",
          borderRadius: "12px",
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.02)",
        }}
      >
        <div style={{ width: "100%", height: 450 }}>
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart
              data={financialData}
              margin={{ top: 15, right: 5, left: 5, bottom: 5 }}
            >
              {/* Vibrant gradients fine-tuned for Light Backgrounds */}
              <defs>
                <linearGradient id="incomeGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#4ade80" stopOpacity={1} />
                  <stop offset="100%" stopColor="#22c55e" stopOpacity={0.4} />
                </linearGradient>
                <linearGradient id="expenseGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#f87171" stopOpacity={1} />
                  <stop offset="100%" stopColor="#ef4444" stopOpacity={0.4} />
                </linearGradient>
                <linearGradient id="profitGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#60a5fa" stopOpacity={1} />
                  <stop offset="100%" stopColor="#3b82f6" stopOpacity={0.4} />
                </linearGradient>
                <linearGradient id="lineGrad" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stopColor="#b45309" />
                  <stop offset="100%" stopColor="#d97706" />
                </linearGradient>
              </defs>

              {/* Light grid layout */}
              <CartesianGrid
                strokeDasharray="3 3"
                vertical={false}
                stroke="#f1f5f9"
              />

              <XAxis
                dataKey="Month"
                tick={{ fill: "#64748b", fontSize: 12, fontWeight: 500 }}
                axisLine={{ stroke: "#cbd5e1" }}
                tickLine={false}
              />

              {/* Left axis (Dollars) */}
              <YAxis
                yAxisId="left"
                tickFormatter={(v) => `${v.toLocaleString()}`}
                tick={{ fill: "#64748b", fontSize: 12 }}
                axisLine={false}
                tickLine={false}
              />

              {/* Right axis (Margins) */}
              <YAxis
                yAxisId="right"
                orientation="right"
                tickFormatter={(v) => `${v.toFixed(0)}%`}
                tick={{ fill: "#d97706", fontSize: 12, fontWeight: 500 }}
                axisLine={false}
                tickLine={false}
              />

              {/* Custom Crisp Light Tooltip */}
              <Tooltip
                formatter={(value, name) => {
                  if (name === "Profit Margin %")
                    return [`${value.toFixed(2)}%`, name];
                  return [formatCurrency(value), name];
                }}
                contentStyle={{
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  border: "1px solid #e2e8f0",
                  color: "#334155",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                }}
                cursor={{ fill: "#f8fafc" }}
              />

              <Legend
                wrapperStyle={{
                  paddingTop: "24px",
                  fontSize: "13px",
                  fontWeight: 500,
                }}
                iconType="circle"
                iconSize={10}
              />

              <ReferenceLine
                yAxisId="left"
                y={0}
                stroke="#cbd5e1"
                strokeWidth={1.5}
              />

              {/* Gradient filled bars with rounded tops */}
              <Bar
                yAxisId="left"
                dataKey="Income"
                fill="url(#incomeGrad)"
                name="INCOME"
                radius={[4, 4, 0, 0]}
                maxBarSize={32}
              />
              <Bar
                yAxisId="left"
                dataKey="Expense"
                fill="url(#expenseGrad)"
                name="EXPENSE"
                radius={[4, 4, 0, 0]}
                maxBarSize={32}
              />
              <Bar
                yAxisId="left"
                dataKey="NetProfit"
                fill="url(#profitGrad)"
                name="NET PROFIT"
                radius={[4, 4, 0, 0]}
                maxBarSize={32}
              />

              {/* Deep Amber Monotone Line Layer */}
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="ProfitPercent"
                stroke="url(#lineGrad)"
                strokeWidth={3}
                name="Profit Margin %"
                dot={{
                  r: 4,
                  fill: "#d97706",
                  stroke: "#ffffff",
                  strokeWidth: 2,
                }}
                activeDot={{ r: 6, strokeWidth: 0 }}
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>

       {/* Sticky Close Bar */}
       <div
        style={{
          position: "sticky",
          bottom: 0,
          zIndex: 10,
          display: "flex",
          justifyContent: "flex-end",
          padding: "8px 4px",
          marginTop: "12px",
          backgroundColor: "#f8fafc",
          borderTop: "1px solid #e2e8f0",
        }}
      >
        <button
          onClick={onClose}
          className="w-full py-3 bg-gradient-to-r from-rose-500 to-pink-500 text-white rounded-xl text-sm font-semibold hover:shadow-lg hover:opacity-95 active:scale-[0.99] transition-all tracking-wider uppercase"
        >
          Close
        </button>
      </div>

    </div>
  );
}
